import type { ReactNode } from 'react';
import { ErrorState, Loading } from '../components/States';
import { useProfile } from '../hooks/api-hooks';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const profile = useProfile();

  if (profile.isPending) return <Loading label="Đang kiểm tra quyền quản trị…" />;
  if (profile.error) return <ErrorState error={profile.error} />;
  if (profile.data?.role !== 'ADMIN') {
    return (
      <section className="panel">
        <h1>Không có quyền truy cập</h1>
        <p className="muted">Tài khoản này chưa được cấp vai trò quản trị.</p>
      </section>
    );
  }

  return <>{children}</>;
}
